import { useContext } from 'react';
import { ThemesContext } from '@context';

export const useThemes = () => {
    const context = useContext(ThemesContext);
    if (!context) {
        throw new Error('useThemes must be used within a ThemesProvider');
    }
    return context;
};
